module.exports = __webpack_public_path__ + "static/media/Arrow.6bfa9fb9.svg";